import service from "../providers/service.js";
import { tokenize } from "../helpers/token.js";
import { setErrors } from "./error.js";
import { SET_USER_TIMESHEETS, SET_COMPANY_TIMESHEETS } from "./types";

/**
 * Fetch all timesheets for user by id
 * @param {number} userId 
 */
export function fetchTimsheetsForUser(userId) {
  return dispatch => {
    service
      .get(tokenize(`/api/timesheets/${userId}`))
      .then(response => {
        dispatch(setTimesheets(response.data.timesheets));
      }).catch(err => {
        console.log(err);
      })
  }
}

/**
 * Fetch all timesheets for company by id
 * @param {number} companyId
 */
export function fetchTimsheetsForCompany(companyId) {
  return dispatch => {
    service
      .get(tokenize(`/api/timesheets/company/${companyId}`))
      .then(response => {
        dispatch(setTimesheets(response.data.timesheets, 'company'));
      }).catch(err => {
        console.log(err);
      })
  }
}

/**
 * Update timesheet on backend
 * 
 * @param {number} userId 
 * @param {object} timesheetData 
 */
export function updateTimesheets(userId, timesheetData) {
  return (dispatch) => {
    const config = { headers: { 'Content-Type': 'json' } };

    if (timesheetData.length > 0) {
      service
        .post(tokenize(`/api/timesheets/update`), { timesheets: timesheetData }, config)
        .then(response => {
          if (response.data.message === 'timesheet.success') {
            dispatch(fetchTimsheetsForUser(userId));
            alert('Timesheet data has been Updated!');
          }

          if (response.data.errors) {
            dispatch(setErrors(response.data.errors));
            alert('An error has occured!');
          }
        }).catch((err) => {
          console.log(err);
        })
    }
  };
}

/**
 * Save attachments to redux store
 * @param {array} timesheets 
 * @param {string} type 
 */
export function setTimesheets(timesheets, type = 'user') {
  return {
    type: type === 'user' ? SET_USER_TIMESHEETS : SET_COMPANY_TIMESHEETS,
    timesheets: timesheets
  };
}


// WEBPACK FOOTER //
// ./src/actions/timesheet.js